import api from '../../utils/api';

import {
  CONFIRMATION_STEP,
  SEARCH_CRITERIA_STEP,
  FILE_UPLOAD_STEP,
} from './constants';

const recoveryApiPrefix = '/recovery/account/reset_requests';

export const validateActiveEmail = (values, callbacks, toStep) => {
  const { activeEmail } = values;
  const { setSubmitting, setErrors } = callbacks;
  setSubmitting(true);

  return api
    .postRetry(`${recoveryApiPrefix}/validate_active`, {
      activeCredential: activeEmail,
    })
    .then(() => {
      setSubmitting(false);
      toStep(FILE_UPLOAD_STEP);
    })
    .catch(err => {
      setSubmitting(false);
      const error = err.jsonResponse.error;
      setErrors({ activeEmail: error });
    });
};

export const createResetRequest = (values, callbacks, toStep, stepHistory) => {
  const { setSubmitting, setErrors } = callbacks;
  setSubmitting(true);

  const {
    newEmail,
    activeEmail,
    fileUpload,
    firstname,
    lastname,
    birthdate,
    city,
    possibleEmail1,
    possibleEmail2,
  } = values;

  const formData = new window.FormData();
  formData.append('image', fileUpload);
  formData.append('new_email', newEmail);

  let resetRequestEndpoint = `${recoveryApiPrefix}/create_no_access_request`;

  if (stepHistory.includes(SEARCH_CRITERIA_STEP)) {
    resetRequestEndpoint = `${recoveryApiPrefix}/create_forgot_credentials_request`;

    formData.append('first_name', firstname);
    formData.append('last_name', lastname);
    formData.append('birth_date', birthdate);
    formData.append('city', city);
    formData.append('possible_email_1', possibleEmail1);
    formData.append('possible_email_2', possibleEmail2);
  } else {
    formData.append('active_credential', activeEmail);
  }

  return api
    .postMultiPart(resetRequestEndpoint, formData)
    .then(() => {
      setSubmitting(false);
      toStep(CONFIRMATION_STEP);
    })
    .catch(err => {
      setSubmitting(false);
      const error = err.jsonResponse.error;
      setErrors({ newEmailError: error });
    });
};

export const confirmResetRequest = (values, callbacks, replace) => {
  const { confirmationCode } = values;
  const { setSubmitting, setErrors } = callbacks;
  setSubmitting(true);

  return api
    .post(`${recoveryApiPrefix}/confirm_code`, { confirmationCode })
    .then(() => {
      setSubmitting(false);
      replace({
        pathname: '/recovery/account/success',
      });
    })
    .catch(err => {
      setSubmitting(false);
      const error = err.jsonResponse.error;
      setErrors({ confirmationCodeError: error });
    });
};

export const getResetRequest = replace => {
  return api
    .get(recoveryApiPrefix)
    .then(response => {
      const { newEmail } = response;
      return { newEmail };
    })
    .catch(err => {
      const { error } = err.jsonResponse;
      replace({
        pathname: '/recovery/account/no-access',
        search: `?error=${error}`,
      });
    });
};
